
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarTrigger,
} from "@/components/ui/menubar";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";

export default function Navigation() {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  const closeDropdown = () => {
    setActiveDropdown(null);
  };

  return (
    <div className="flex items-center justify-center w-full gap-4">
      <Menubar className="border-white/10 bg-transparent p-0">
        {/* About dropdown */}
        <MenubarMenu>
          <MenubarTrigger className="text-gray-300 hover:text-white transition-colors py-2">
            About
          </MenubarTrigger>
          <MenubarContent className="glass-panel">
            <MenubarItem asChild>
              <Link
                to="/about"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                Who is Aram AI?
              </Link>
            </MenubarItem>
            <MenubarItem asChild>
              <Link
                to="/biography"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                Biography
              </Link>
            </MenubarItem>
          </MenubarContent>
        </MenubarMenu>

        {/* Products dropdown */}
        <MenubarMenu>
          <MenubarTrigger className="text-gray-300 hover:text-white transition-colors py-2">
            Products/Services
          </MenubarTrigger>
          <MenubarContent className="glass-panel">
            <MenubarItem asChild>
              <Link
                to="/products/prompt-manager"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                Prompt Manager
              </Link>
            </MenubarItem>
            <MenubarItem asChild>
              <Link
                to="/products/ai-automation"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                AI Automation
              </Link>
            </MenubarItem>
            <MenubarItem asChild>
              <Link
                to="/products/vasilenko-ai"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                Vasilenko AI
              </Link>
            </MenubarItem>
          </MenubarContent>
        </MenubarMenu>

        {/* Resources dropdown */}
        <MenubarMenu>
          <MenubarTrigger className="text-gray-300 hover:text-white transition-colors py-2">
            Resources
          </MenubarTrigger>
          <MenubarContent className="glass-panel">
            {/* <MenubarItem asChild>
              <Link
                to="/vibe-course"
                target="_blank"
                rel="noreferrer"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                ⚡️ Vibe Coding Course
              </Link>
            </MenubarItem> */}
            <MenubarItem asChild>
              <a
                href="https://t.me/viberimej_bot"
                target="_blank"
                rel="noreferrer"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                «Վայբանոց» Community
              </a>
            </MenubarItem>
            <MenubarItem asChild>
              <a
                href="https://t.me/haieren"
                target="_blank"
                rel="noreferrer"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                AI Automated Newsletter
              </a>
            </MenubarItem>
            <MenubarItem asChild>
              <a
                href="https://www.youtube.com/@iamaramai"
                target="_blank"
                rel="noreferrer"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                YouTube
              </a>
            </MenubarItem>
            <MenubarItem asChild>
              <a
                href="https://www.instagram.com/iamaram.ai/"
                target="_blank"
                rel="noreferrer"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                Instagram
              </a>
            </MenubarItem>
            <MenubarItem asChild>
              <a
                href="https://www.linkedin.com/in/aramai"
                target="_blank"
                rel="noreferrer"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                LinkedIn
              </a>
            </MenubarItem>
          </MenubarContent>
        </MenubarMenu>

        {/* Past Projects dropdown */}
        <MenubarMenu>
          <MenubarTrigger className="text-gray-300 hover:text-white transition-colors py-2">
            Past Projects
          </MenubarTrigger>
          <MenubarContent className="glass-panel">
            <MenubarItem asChild>
              <Link
                to="/projects/amazon"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                Amazon FBA/Fulfilled by us
              </Link>
            </MenubarItem>
            <MenubarItem asChild>
              <Link
                to="/projects/upwork"
                className="cursor-pointer hover:bg-white/10 hover:text-white transition-colors"
                onClick={closeDropdown}
              >
                Upwork
              </Link>
            </MenubarItem>
          </MenubarContent>
        </MenubarMenu>
      </Menubar>
      
      {/* Special donate button with pixelated heart - Updated with animate-heartbeat */}
      {/* <Button 
        asChild
        variant="outline" 
        className="gradient-border bg-black/60 border border-[#9b87f5] hover:bg-black/80 text-white"
      >
        <Link to="/donate" className="flex items-center gap-1">
          <div className="w-5 h-5 flex items-center justify-center animate-heartbeat">
            <img 
              src="/lovable-uploads/db0a8c1d-0735-4000-94e6-b2c38cd9e104.png" 
              alt="Pixelated heart" 
              className="w-full h-full object-contain"
            />
          </div>
          Donate
        </Link>
      </Button> */}
    </div>
  );
}
